const en = {
    'ui.menus.user.home': 'Home',
    'ui.menus.user.company': 'Company',
    'ui.menus.user.documents': 'Documents',
    'ui.menus.user.portal': 'Portal',
    'ui.menus.user.users': 'Users',
    'ui.menus.user.admin': 'Administration',
    'ui.menus.user.proposalProject': 'Proposal Project',
    'ui.menus.user.logout': 'Logout',
    'ui.menus.user.hello': 'Hello',
    'ui.menus.user.signing': 'Signing',
    'ui.menus.user.applications': 'Applications',

    'ui.menus.admin.home': 'Home',
    'ui.menus.admin.users': 'User Management',
    'ui.menus.admin.permissionGroups': 'Permission Groups Management',
    'ui.menus.admin.jobPositions': 'Job Positions (Permissions)',
    'ui.menus.admin.permissions': 'Permissions Management',
    'ui.menus.admin.scheduledCommands': 'Scheduled Commands Management',
    'ui.menus.admin.user': 'User View',
    'ui.menus.admin.logout': 'Logout',
    'ui.menus.admin.proposalProject': 'Proposal Project',
    'ui.menus.user.csAlertConfiguration': 'CS Alert Configuration',

    'ui.application.aszende_app': 'Intranet Aszende app',
    'ui.application.corporate_webmail': 'Corporate webmail',
    'ui.application.learning_aszende': 'Learning Aszende',
    'ui.application.binsa': 'Binsa',
    'ui.application.crm': 'CRM',
    'ui.application.it_portal': 'IT Portal',
    'ui.application.agile': 'Agile',
    'ui.application.salesforce': 'Salesforce',
    'ui.application.power_bi': 'Power Bi',
    'ui.application.anydesk': 'Anydesk',
    'ui.application.jori': 'Jori - Flexible remuneration',
    'ui.application.web_fleet_solutions': 'Webfleet solutions',
    'ui.application.aszende_fleet': 'Aszende fleets',
    'ui.application.hydra': 'Hydra - Dialoga',
    'ui.menus.user.extra': 'Extra',
    'ui.menus.user.installationExtra': 'Installation Extra'
};

export default en;